export const START_OF_TIME = "1900-01-01";
export const END_OF_TIME = "3000-01-01";
export var HeadCountType;
(function (HeadCountType) {
    HeadCountType["PLAN"] = "PLAN";
    HeadCountType["CHANGE"] = "CHANGE";
})(HeadCountType || (HeadCountType = {}));
export var HeadCountFileFormat;
(function (HeadCountFileFormat) {
    HeadCountFileFormat["CFF"] = "CFF";
    HeadCountFileFormat["BEHOVSVERKTYG"] = "BEHOVSVERKTYG";
    HeadCountFileFormat["INVISION"] = "INVISION";
    HeadCountFileFormat["TEMPLATE"] = "TEMPLATE";
    HeadCountFileFormat["MST_SWITZERLAND"] = "MST_SWITZERLAND";
    HeadCountFileFormat["TEMPLATE_ACTIVITY"] = "TEMPLATE_ACTIVITY";
})(HeadCountFileFormat || (HeadCountFileFormat = {}));
// Types of files that do not require selection of Activity in Upload Form
// they contain headcount within selected Unit
export const FORMATS_WITH_ACTIVITIES = [
    HeadCountFileFormat.CFF,
    HeadCountFileFormat.MST_SWITZERLAND,
    HeadCountFileFormat.TEMPLATE_ACTIVITY,
];
// Types of files that can contain job paths inside that belong to different Units
export const FORMATS_FOR_MANY_UNITS = [HeadCountFileFormat.CFF];
export var View;
(function (View) {
    View[View["DAYQUARTERS"] = 0] = "DAYQUARTERS";
    View[View["DAY"] = 1] = "DAY";
    View[View["WEEK"] = 2] = "WEEK";
})(View || (View = {}));
//# sourceMappingURL=types.mjs.map